import React from 'react';
import '../AdvertiserToolTip.scss';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import classnames from 'classnames';

const AdvertiserToolTipView = props => {
  const {
    datatestid,
    className,
    partnerText = 'Offers from our partners',
    vertical,
    pageName,
    disclaimer,
    pagePosition,
    disclosure,
  } = props;

  const containerClass = classnames(
    'disclaimerContainer justify-between',
    className,
    {
      [`withPartnerText flex-container flex-row`]: true,
    },
  );

  return (
    <div
      data-testid={`${datatestid ? datatestid : ''}-disclaimerContainer`}
      className={containerClass}
    >
      <div className="partnerText system_neutral_n400_text">{partnerText}</div>
      <CSTooltip
        className="flex-container"
        tooltipName="Advertiser Disclosure"
        vertical={vertical}
        title=""
        placement="bottomRight"
        pageName={pageName}
        tooltipContent={
          <div
            data-testid={`${datatestid ? datatestid : ''}-disclaimerContent`}
            className="advertiser-claimer"
            dangerouslySetInnerHTML={{
              __html: disclaimer,
            }}
          />
        }
        pagePosition={pagePosition}
      >
        <div
          data-testid={`${datatestid ? datatestid : ''}-disclaimerTitle`}
          className={'disclaimer padtpbt10 otherLink'}
        >
          {disclosure}
        </div>
      </CSTooltip>
    </div>
  );
};

export default AdvertiserToolTipView;
